import React from 'react';
import * as S from './styles';

const ImageBackground = (props = {}) => (
    <S.ImageBackground
        extraSmall={props.extraSmall}
        extraSmall2x={props.extraSmall2x || undefined}
        small={props.small}
        small2x={props.small2x || undefined}
        medium={props.medium}
        medium2x={props.medium2x || undefined}
        extraLarge={props.extraLarge}
        extraLarge2x={props.extraLarge2x || undefined}
    />
);

export default ImageBackground;
